import { render, staticRenderFns } from "./ModalRoleAndGroup.vue?vue&type=template&id=ab99dacc&scoped=true"
import script from "./ModalRoleAndGroup.vue?vue&type=script&lang=js"
export * from "./ModalRoleAndGroup.vue?vue&type=script&lang=js"
import style0 from "./ModalRoleAndGroup.vue?vue&type=style&index=0&id=ab99dacc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab99dacc",
  null
  
)

export default component.exports